import qs from 'query-string'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { checkTableValid } from './actions/orderActions'
import { ACCESS_SERVICES_MAP, APP_SERVICE, ORDER_METHOD, PARAMS_NAME, StorageKeys } from './constants'

import LoadingContainer from './containers/LoadingContainer'
import ModalTableQrcodePrinter from './containers/modal/ModalTableQrcodePrinter'
import ModalTableQrcodeQuestion from './containers/modal/ModalTableQrcodeQuestion'
import ModalExpireTime from './containers/ModalExpireTime'
import ModalOvertimeContainer from './containers/ModalOvertimeContainer'
import ModalTabletQRCodeType from './containers/ModalTabletQRCodeType'
import ModalTakeAGoStatus from './containers/ModalTakeAGoStatus'
import ModalWebStatus from './containers/ModalWebStatus'
import OrderMethodContainer from './containers/order/OrderMethodContainer'
// import LoginContainer from './containers/LoginContainer'
import ValidContext from './containers/ValidContext'
import useLastActive from './hooks/useLastActive'
import paths from './routes/paths'
import { disableBrowserBack } from './utils/helper'
import ModalCloseContainer from './containers/ModalCloseContainer'

const App = ({ children }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const restaurantInfo = useSelector(state => state.RestaurantReducer)
    const orderMethod = useSelector(state => state.OrderReducer.orderMethod)
    useLastActive()

    const [isValid, setIsValid] = useState(false)

    const checkServiceServe = service => {
        const services = restaurantInfo.services
        if (service === ACCESS_SERVICES_MAP.WEB) {
            return [
                ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP],
                ACCESS_SERVICES_MAP[ORDER_METHOD.DELIVERY],
            ].some(ser => services.includes(ser))
        }

        return services.includes(ACCESS_SERVICES_MAP[service])
    }

    useEffect(() => {
        disableBrowserBack()
        const params = qs.parse(history.location.search)
        const { pathname } = history.location

        if (
            params[PARAMS_NAME.ORDER_GO_ID] ||
            params[PARAMS_NAME.ORDER_WEB_ID] ||
            pathname.includes(paths.unSupport) ||
            pathname.includes(paths.notFound)
        ) {
            return setIsValid(true)
        }

        if (
            !checkServiceServe(APP_SERVICE) ||
            (APP_SERVICE === ACCESS_SERVICES_MAP.WEB &&
                (pathname.includes(paths.verifyTable) ||
                    pathname.includes(paths.verifyQRCode))) ||
            (APP_SERVICE === ORDER_METHOD.QR_CODE &&
                orderMethod !== ORDER_METHOD.QR_CODE &&
                !pathname.includes(paths.verifyTable)) ||
            (APP_SERVICE === ORDER_METHOD.TABLE_QRCODE &&
                orderMethod !== ORDER_METHOD.TABLE_QRCODE &&
                !pathname.includes(paths.verifyQRCode))
        ) {
            // invalid
            history.push({
                pathname: paths.unSupport,
                state: {
                    message: t('message.unSupportService'),
                },
            })
        }

        if (
            orderMethod === ORDER_METHOD.QR_CODE &&
            !pathname.includes(paths.verifyTable)
        ) {
            return dispatch(
                checkTableValid({
                    onDone: isValid => setIsValid(isValid),
                })
            )
        }

        setIsValid(true)
    }, [])

    useEffect(() => {
        if (history.action === 'PUSH') {
            window.scroll(0, 0)
        }
    }, [history.location.pathname])

    useEffect(() => {
        const appHeight = () => {
            const lastInnerHeight = window.sessionStorage.getItem(StorageKeys.lastInnerHeight)
            const doc = document.documentElement
            doc.style.setProperty('--app-height', `${lastInnerHeight ?? window.innerHeight}px`)
            if (lastInnerHeight) {
                window.sessionStorage.removeItem(StorageKeys.lastInnerHeight)
            }
        }
        appHeight()

        window.addEventListener('resize', appHeight)

        return () => {
            window.removeEventListener('resize', appHeight)
        }
    }, [])

    return (
        <>
            {/* <LoginContainer /> */}
            <LoadingContainer />
            <ToastContainer />
            <ValidContext />

            <ModalTableQrcodeQuestion />
            <ModalTableQrcodePrinter />

            {isValid && (
                <>
                    <ModalWebStatus />
                    <ModalTakeAGoStatus />
                    <ModalExpireTime />
                    <OrderMethodContainer />
                    <ModalTabletQRCodeType />
                    <ModalOvertimeContainer />
                    <ModalCloseContainer />
                    {children}
                </>
            )}
        </>
    )
}

export default App
